import { Box, styled } from "@mui/material";

export const BoxLoader = styled(Box)(({ theme }) => ({
  height: "70vh",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));
